// Navigation structures: main/vehicle side-menu entries, dashboard tabs, and local (frontend) route paths.
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */

import GroupIcon from "@mui/icons-material/Group";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import SettingsIcon from "@mui/icons-material/Settings";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ArticleIcon from "@mui/icons-material/Article";
import GroupsIcon from "@mui/icons-material/Groups";

import DashboardIcon from "@mui/icons-material/Dashboard";
import NoCrashIcon from "@mui/icons-material/NoCrash";
import SecurityIcon from "@mui/icons-material/Security";
import ConstructionIcon from "@mui/icons-material/Construction";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import PaidIcon from "@mui/icons-material/Paid";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { Vocabulary } from "../Utils/Vocabulary";
import { ReportsTab, TemplatesTab } from "../Utils/autocompleteEnum";

export const localUrlEnum = {
  settings: [
    "settings",
    "salaryConfigurations",
    "statusVehicle",
    "roles",
    "permissions",
    "shipping",
    "companies",
    "websitesIntegration",
    "notifications",
  ],
  reportsTab: [
    ReportsTab.statistically,
    ReportsTab.vehicles,
    ReportsTab.brands,
    ReportsTab.models,
    ReportsTab.administrativeLocations,
    ReportsTab.shipping,
  ],
  templatesTab: [TemplatesTab.templates, TemplatesTab.generateDocuments],
  reports: "/reports",
  vehiclesTab: [
    "unsold",
    "sold",
    "reserved",
    "partialVehicles",
    "onDemandVehicles",
  ],
  messagesTab: ["unassigned", "assigned", "canceled", "all"],
  carOrdersTab: ["allocated", "unallocated", "canceled"],
  financialTab: [
    "unpaid",
    "paid",
    "advancePaid",
    "contractToSign",
    "contractSigned",
  ],
  vehicles: "/vehiclesDashboard",
  users: "/usersDashboard",
  administrativeCosts: "/administrativeCosts",
  financialDepartment: "/financialDepartment",
  acquisitions: "/acquisitions",
  sales: "/sales",
  onDemand: "/onDemand",
  logistics: "/logistics",
  vehicle: "vehicleDashboard",
  clientMessages: "/clientMessages",
  financingRequests: "/financingRequests",
  vinRequests: "/vinRequests",
  logs: "/logs",
  login: "/login",
  documents: "/documents",
  xautoVehicles: "/xautoVehicles",
  xautoVehiclesActive: "/xautoVehicles/active",
  xautoVehiclesDeactivated: "/xautoVehicles/deactivated",
  leadDetail: "/clientMessages",
};

//MAIN SLIDER

export const MainSliderData = [
  {
    name: Vocabulary.usersName,
    path: "/usersDashboard",
    icon: <GroupIcon />,
  },
  {
    name: Vocabulary.clientsName,
    path: "/clients",
    icon: <GroupsIcon />,
  },
  {
    name: Vocabulary.vehicles,
    path: "/vehiclesDashboard/",
    icon: <DirectionsCarIcon />,
  },
  {
    name: Vocabulary.tasksName,
    path: "/tasks-backlog",
    icon: <AssignmentTurnedInIcon />,
  },
  {
    name: Vocabulary.settings,
    path: "/settings",
    icon: <SettingsIcon />,
  },
  {
    name: Vocabulary.templatesName,
    path: "/templates",
    icon: <ArticleIcon />,
  },
  {
    name: Vocabulary.reportsName,
    path: "/reports",
    icon: <AssessmentIcon />,
  },
  {
    name: Vocabulary.costsName,
    path: localUrlEnum.administrativeCosts,
    icon: <RequestPageIcon />,
  },
  {
    name: Vocabulary.logsName,
    path: localUrlEnum.logs,
    icon: <AssignmentIndIcon />,
  },
];

export const DefaultVehicleSliderData = null;

//VEHICLE SLIDER
export const VehicleSliderData = [
  {
    name: Vocabulary.dashboard,
    path: `/vehiclesDashboard/vehicleDashboard/`,
    icon: <DashboardIcon />,
    id: "vehicleDashboard",
  },
  {
    name: Vocabulary.detaliiVehicul,
    path: "/vehiclesDashboard/vehicleDetails/",
    icon: <NoCrashIcon />,
    id: "vehicleDetails",
  },
  {
    name: Vocabulary.intrareGarantie,
    path: "/vehiclesDashboard/vehicleGuarantees/",
    icon: <SecurityIcon />,
    id: "vehicleGuarantees",
    slug: "intrare_garantie",
  },
  {
    name: Vocabulary.service,
    path: "/vehiclesDashboard/vehicleService/",
    icon: <ConstructionIcon />,
    id: "vehicleService",
    slug: "interventii_service",
  },
  {
    name: Vocabulary.detailing,
    path: "/vehiclesDashboard/vehicleDetailing/",
    icon: <LocalCarWashIcon />,
    id: "vehicleDetailing",
    slug: "interventii_detailing",
  },
  {
    name: Vocabulary.vopsitorie,
    path: "/vehiclesDashboard/vehiclePainting/",
    icon: <FormatPaintIcon />,
    id: "vehiclePainting",
    slug: "interventii_vopsitorie",
  },
  {
    name: Vocabulary.costAditional,
    path: "/vehiclesDashboard/vehicleAdditionalCost/",
    icon: <PaidIcon />,
    id: "vehicleAdditionalCost",
    slug: "costuri_aditionale",
  },
  {
    name: Vocabulary.poze,
    path: "/vehiclesDashboard/vehiclePhotos/",
    icon: <PhotoLibraryIcon />,
    id: "vehiclePhotos",
    slug: "vehiclePhotos",
  },
  {
    name: Vocabulary.documente,
    path: "/vehiclesDashboard/vehicleDocuments/",
    icon: <FileCopyIcon />,
    id: "vehicleDocuments",
    slug: "vehicleDocuments",
  },
];

export const vehiclesTabs = [
  { code: "stock", label: "Stoc Total" },
  { code: "intermediated", label: "Intermediere" },
  { code: "intermediated-deactivated", label: "Intermediere Inactive" },
  { code: "sold", label: "Vandute" },
];
